export const I18TranslationKeys = {
  inputLabel: 'template.page.content.eyes-only.tags.tag.placeholder',
  addButton: 'template.page.content.eyes-only.tags.tag.add-button'
};
